import React from 'react';
import { MdPlayArrow } from 'react-icons/md';
import './index.css';

type ScoreWithScaleProps = {
    className?: string;
    score: number;
    scoreMin: number;
    scoreMax: number;
    fontSize?: number;
};

function ScoreWithScale({
    className,
    score,
    scoreMin,
    scoreMax,
    fontSize = 40
}: ScoreWithScaleProps) {

    const arrowLoc = -32*(score - scoreMin)/(scoreMax - scoreMin) + 28;
    const arrowColor = score - scoreMin >= 0.9 * (scoreMax - scoreMin)
        ? 'var(--green)'
        : score - scoreMin >= 0.5 * (scoreMax - scoreMin)
        ? 'var(--yellow)'
        : 'var(--red)';


    return (
        <div className={`scoreWithScale ${className}`}>
            <p
                className='scoreWithScale__score'
                style={{
                    fontSize: fontSize,
                    lineHeight: 0.8
                }}
            >
                {score}
            </p>
            <div className='scoreWithScale__scale'>
                <div className='scoreWithScale__scaleTop'></div>
                <p className='scoreWithScale__scoreMax'>{scoreMax}</p>
                <div className='scoreWithScale__scaleBottom'></div>
                <p className='scoreWithScale__scoreMin'>{scoreMin}</p>
                <MdPlayArrow
                    className='scoreWithScale__arrow'
                    style={{
                        top: arrowLoc,
                        color: arrowColor
                    }}
                />
            </div>
        </div>
    );
}

export default ScoreWithScale;